import AnimatedSection from '../../../components/base/AnimatedSection';

const WA_RESERVAR =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function ComoReservar() {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center">
              Cómo reservar
            </h2>
          </AnimatedSection>

          <div className="space-y-6 mb-12">
            <AnimatedSection animation="fadeLeft" delay={0}>
              <div className="flex items-start gap-6 bg-gray-900 rounded-xl p-8 border border-gray-800">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-full font-bold text-xl flex-shrink-0">
                  1
                </div>
                <div>
                  <p className="text-lg text-white">
                    Completas{" "}
                    <a
                      href="https://forms.gle/4hbhn5ZtpxWFVR4G9"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-semibold hover:text-teal-400 transition-colors underline cursor-pointer"
                    >
                      este formulario
                    </a>
                  </p>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection animation="fadeLeft" delay={100}>
              <div className="flex items-start gap-6 bg-gray-900 rounded-xl p-8 border border-gray-800">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-full font-bold text-xl flex-shrink-0">
                  2
                </div>
                <div>
                  <p className="text-lg text-white">
                    Te enviamos confirmación de cupo.
                  </p>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection animation="fadeLeft" delay={200}>
              <div className="flex items-start gap-6 bg-gray-900 rounded-xl p-8 border border-gray-800">
                <div>
                  <p className="text-lg text-white">
                    También podés contactarnos por WhatsApp con cualquier duda o
                    para realizar el pago del curso.
                  </p>
                </div>
              </div>
            </AnimatedSection>
          </div>

          <AnimatedSection animation="fadeUp" delay={100}>
            <div className="bg-teal-500/20 border-l-4 border-teal-500 rounded-lg p-6 mb-12">
              <p className="text-lg text-white font-semibold">
                Cupos restantes disponibles 15
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection animation="scaleUp" delay={200}>
            <div className="text-center">
              <a
                href={WA_RESERVAR}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-12 py-5 bg-teal-500 text-white rounded-lg font-bold text-xl hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-2xl hover:shadow-teal-500/50"
              >
                Reservar por WhatsApp
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
